export default "__VITE_ASSET__64e1835c__"